import { useState } from 'react';
import { Duck } from '../components/Duck';
import type { MascotName } from '../theme/ThemeProvider';

type Props = {
  mascot: MascotName;
  registrations: number;
  onRegister: () => void;
};

export function RegisterCTA({ mascot, registrations, onRegister }: Props): JSX.Element {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);

  return (
    <section
      id="register"
      className="relative overflow-hidden border-t-2 border-ink bg-ink px-8 py-24 text-bg"
    >
      <div aria-hidden className="absolute opacity-20" style={{ top: -40, right: -20 }}>
        <Duck variant={mascot} size={300} />
      </div>
      <div aria-hidden className="absolute opacity-10" style={{ bottom: -60, left: -40, transform: 'scaleX(-1)' }}>
        <Duck variant={mascot} size={240} />
      </div>
      <div className="relative mx-auto max-w-[800px] text-center">
        <h2
          className="m-0 font-display font-black tracking-[-0.04em]"
          style={{ fontSize: 'clamp(40px, 6vw, 84px)', lineHeight: 0.96, textWrap: 'balance' as never }}
        >
          Reserve a seat in the{' '}
          <span className="inline-block bg-duck px-[0.1em] text-ink" style={{ transform: 'rotate(-1.5deg)' }}>
            tub
          </span>
          .
        </h2>
        <p className="mx-auto mt-6 max-w-[560px] text-xl text-white/70">
          Free. No spam. Just a calendar invite, the stream link, and a heads up if your favorite bot melts down.
        </p>
        <form
          className="mx-auto mt-10 flex max-w-[520px] gap-2"
          onSubmit={(e) => {
            e.preventDefault();
            if (email) {
              setDone(true);
              onRegister();
            }
          }}
        >
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@somewhere.dev"
            type="email"
            className="flex-1 rounded-full border-0 bg-bg px-[22px] py-[18px] font-display text-lg font-medium text-ink outline-none"
          />
          <button
            type="submit"
            disabled={done}
            className="whitespace-nowrap rounded-full border-0 px-7 font-display text-lg font-extrabold text-ink disabled:cursor-default"
            style={{ background: done ? 'rgb(var(--color-ai))' : 'rgb(var(--color-duck))' }}
          >
            {done ? "✓ You're in!" : 'Reserve →'}
          </button>
        </form>
        <div className="mt-6 font-mono text-[13px] text-white/50">
          Joining {registrations.toLocaleString()} other engineers and {Math.floor(registrations * 0.04)} confirmed bots.
        </div>
      </div>
    </section>
  );
}
